import React from "react";
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";

export const STATUS_OPTIONS = [
  { label: "All", value: "" },
  { label: "Draft", value: "draft" },
  { label: "Submitted", value: "submitted" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
  { label: "Reopened", value: "reopened" },
];

export default function CvToolbar({
  q,
  setQ,
  status,
  setStatus,
  loading,
  onRefresh,
  onApply,
}) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      gap={2}
      alignItems={{ md: "center" }}
      justifyContent="space-between"
    >
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 950 }}>
          CV Review & Approval
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          Review, edit, approve/reject, reopen, and generate CVs.
        </Typography>
      </Box>

      <Stack direction={{ xs: "column", sm: "row" }} gap={1.25} alignItems={{ sm: "center" }}>
        <TextField
          size="small"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by name, email, employee code..."
          sx={{ width: { xs: "100%", sm: 340 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <Autocomplete
          size="small"
          options={STATUS_OPTIONS}
          value={status}
          onChange={(_, v) => setStatus(v || STATUS_OPTIONS[0])}
          disableClearable
          sx={{ width: { xs: "100%", sm: 210 } }}
          renderInput={(params) => <TextField {...params} label="Status" />}
        />

        <Tooltip title="Refresh">
          <IconButton onClick={onRefresh} disabled={loading}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>

        <Button
          variant="contained"
          onClick={onApply}
          disabled={loading}
          sx={{ fontWeight: 900, borderRadius: 2 }}
        >
          Apply
        </Button>
      </Stack>
    </Stack>
  );
}
